<template>
  <div class="multi-main wrapper" @click.stop.prevent="hideSelect">
    <div class="multi-select wrapper" @click.stop.prevent>
      <h2 class="title-first">Select your Group members</h2>

      <!-- Client -->
      <div class="title" @click.stop="toggleExpansion('clients')">
        Clients
        <a href="#" class="icon-accordion-down" @click.prevent
          ><img
            src="../../../assets/img/icon-accordion-up-b.png"
            :class="{ rotate: !showClients }"
        /></a>
      </div>
      <div
        class="multi-options wrapper"
        :class="{ 'hide-section': !showClients }"
        v-if="clients"
      >
        <div
          class="multi-select option"
          v-for="(client, index) in clients"
          :key="index"
          @click="
            findIndexLocal(client)
              ? removeFromSelected(client)
              : addToSelected(client)
          "
        >
          <span
            class="multi-select check"
            :class="{ selected: findIndexLocal(client) }"
          ></span>
          <span class="multi-select content">{{ client.name | clean }}</span>
        </div>
      </div>
      <div class="multi-options wrapper" v-else>
        <div class="multi-select option">
          <span class="multi-select check"></span>
          <span class="multi-select content">Nothing to select</span>
        </div>
      </div>

      <!-- Other -->
      <div class="title" @click.stop="toggleExpansion('others')">
        Others
        <a href="#" class="icon-accordion-up" @click.prevent>
          <img
            src="../../../assets/img/icon-accordion-up-b.png"
            :class="{ rotate: !showOthers }"
        /></a>
      </div>
      <div
        class="multi-options wrapper"
        :class="{ 'hide-section': !showOthers }"
        v-if="others"
      >
        <div
          class="multi-select option"
          v-for="(person, index) in others"
          :key="index"
          @click="
            findIndexLocal(person)
              ? removeFromSelected(person)
              : addToSelected(person)
          "
        >
          <span
            class="multi-select check"
            :class="{ selected: findIndexLocal(person) }"
          ></span>
          <span class="multi-select content">{{ person.name | clean }}</span>
        </div>
      </div>
      <div class="multi-options wrapper" v-else>
        <div class="multi-select option">
          <span class="multi-select check"></span>
          <span class="multi-select content">Nothing to select</span>
        </div>
      </div>

      <!-- Subscriber -->
      <div class="title" @click.stop.prevent="toggleExpansion('subscribers')">
        Subscribers
        <a href="#" class="icon-accordion-up" @click.prevent
          ><img
            src="../../../assets/img/icon-accordion-up-b.png"
            :class="{ rotate: !showSubscribers }"
        /></a>
      </div>
      <div
        class="multi-options wrapper"
        :class="{ 'hide-section': !showSubscribers }"
        v-if="subscribers && subscribers.length > 0"
      >
        <div
          class="multi-select option"
          v-for="(subscriber, index) in subscribers"
          :key="index"
          @click="
            findIndexLocal(subscriber)
              ? removeFromSelected(subscriber)
              : addToSelected(subscriber)
          "
        >
          <span
            class="multi-select check"
            :class="{ selected: findIndexLocal(subscriber) }"
          ></span>
          <span class="multi-select content">{{
            subscriber.name | clean
          }}</span>
        </div>
      </div>
      <div class="multi-options wrapper" v-else>
        <div class="multi-select option">
          <span class="multi-select check"></span>
          <span class="multi-select content">Nothing to select</span>
        </div>
      </div>

      <!-- User -->
      <div class="title" @click.stop.prevent="toggleExpansion('users')">
        Users
        <a href="#" class="icon-accordion-up" @click.prevent
          ><img
            src="../../../assets/img/icon-accordion-up-b.png"
            :class="{ rotate: !showUsers }"
        /></a>
      </div>
      <div
        class="multi-options wrapper"
        :class="{ 'hide-section': !showUsers }"
        v-if="users"
      >
        <div
          class="multi-select option"
          v-for="(user, index) in users"
          :key="index"
          @click="
            findIndexLocal(user)
              ? removeFromSelected(user)
              : addToSelected(user)
          "
        >
          <span
            class="multi-select check"
            :class="{ selected: findIndexLocal(user) }"
          ></span>
          <span class="multi-select content">{{ user.name | clean }}</span>
        </div>
      </div>
      <div class="multi-options wrapper" v-else>
        <div class="multi-select option">
          <span class="multi-select check"></span>
          <span class="multi-select content">Nothing to select</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "MultipSelectGroup",
  data() {
    return {
      showClients: false,
      showOthers: false,
      showSubscribers: false,
      showUsers: false
    };
  },
  computed: {
    ...mapGetters({
      getAppointmentType: "getAppointmentType",
      selectedProviderId: "getSelectedProviderID"
    }),
    ...mapGetters("group", {
      selected: "getSelected"
    }),
    clients() {
      if (this.selectedProviderId) {
        if (this.selectedProviderId in this.getAppointmentType.clients) {
          return this.getAppointmentType.clients[
            this.selectedProviderId
          ].filter(client => {
            return +client.status !== 2;
          });
        }
      }
      return false;
    },
    others() {
      if (this.selectedProviderId) {
        if (this.selectedProviderId in this.getAppointmentType.people) {
          return this.getAppointmentType.people[this.selectedProviderId];
        }
      }
      return false;
    },
    subscribers() {
      if (this.getAppointmentType.subscribers.length > 0) {
        return this.getAppointmentType.subscribers.filter(subscriber => {
          return subscriber.id !== this.selectedProviderId;
        });
      }
      return false;
    },
    users() {
      if (this.selectedProviderId) {
        if (this.selectedProviderId in this.getAppointmentType.appUsers) {
          return this.getAppointmentType.appUsers[this.selectedProviderId];
        }
      }
      return false;
    }
  },
  props: {
    hideSelect: Function,
    showSelect: Boolean
  },
  filters: {
    clean(value) {
      value = value.replace(/&amp;/g, "&").replace(/&amp;/g, "&");
      return value;
    }
  },
  methods: {
    ...mapMutations("group", {
      addToSelected: "addToSelected",
      removeFromSelected: "removeFromSelected"
    }),
    findIndexLocal(user) {
      return (
        this.selected.findIndex(curUser => {
          return curUser.id === user.id && curUser.type === user.type;
        }) !== -1
      );
    },
    toggleExpansion(name) {
      switch (name) {
        case "clients":
          this.showClients = !this.showClients;
          this.showOthers = false;
          this.showSubscribers = false;
          this.showUsers = false;
          break;

        case "others":
          this.showOthers = !this.showOthers;
          this.showClients = false;
          this.showSubscribers = false;
          this.showUsers = false;
          break;

        case "subscribers":
          this.showSubscribers = !this.showSubscribers;
          this.showClients = false;
          this.showOthers = false;
          this.showUsers = false;
          break;

        case "users":
          this.showUsers = !this.showUsers;
          this.showClients = false;
          this.showOthers = false;
          this.showSubscribers = false;
          break;

        default:
          break;
      }
    }
  }
};
</script>

<style scoped>
.multi-main.wrapper {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.multi-main.wrapper:hover {
  cursor: default;
}

.multi-select.wrapper {
  padding: 5% 5% 5% 5%;
  background-color: white;
  flex-flow: column;
  max-height: 70vh;
  overflow-y: auto;
}

.multi-select .title {
  font-size: 20px;
  margin-top: 20px;
  margin-bottom: 5px;
}

.multi-select .title-first {
  font-size: 20px;
  margin-bottom: 5px;
}

.multi-select.option {
  padding: 2%;
  border-bottom: 1px solid #eeeded;
  font-size: 16px;
  transition: all 0.2s ease-in-out;
}

.multi-select.option:hover {
  background-color: #eeeded;
}

.multi-select.option {
  display: flex;
}

.multi-select.option:hover {
  cursor: pointer;
}

.multi-select.check {
  width: 5px;
  height: 5px;
  margin-right: 10px;
  position: relative;
  top: 7px;
}

.multi-select.selected {
  border-radius: 10px;
  background-color: #5888c5;
}

#add-contact-l2 .multi-select.wrapper {
  padding: 10px 20px;
  border-radius: 5px;
  margin-top: 100px;
  overflow-y: auto;
}

#add-contact-l2 .multi-select.wrapper h2 {
  color: #d26d13;
  margin: 5px 0 25px 0;
  font-weight: bold;
  font-size: 18px;
  padding-top: 5px;
  border-bottom: none;
}

#add-contact-l2 .multi-select .title {
  border-bottom: 1px solid #ebebeb;
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 10px;
  margin-bottom: 0px;
  position: relative;
  color: #444;
  margin-top: 10px;
}

#add-contact-l2 .multi-select .title a.icon-accordion-down,
#add-contact-l2 .multi-select .title a.icon-accordion-up {
  position: absolute;
  right: 0;
  top: 0;
  width: 16px;
  height: 16px;
}

#add-contact-l2 .multi-options.wrapper {
  overflow-y: auto;
  max-height: 170px;
  margin-bottom: 0;
  margin-right: 5px;
  margin-top: 5px;
  width: 100%;
}
#add-contact-l2 .multi-select.option {
  line-height: 24px;
  font-size: 14px;
  border-bottom: 1px solid #f6f6f6;
  width: 90%;
}
#add-contact-l2 .multi-select.check {
  width: 10px;
  height: 10px;
}
.multi-options.wrapper {
  transition: all 0.2s ease-in-out;
}

.hide-section {
  max-height: 0px !important;
}

img {
  transition: all 0.3s ease-in-out;
}

.rotate {
  transform: rotate(180deg);
}
</style>
